<template>
	<div class="register bg-img">
		<vs-row vs-justify="center">
			<vs-col class="registerBox" vs-align="center" vs-lg="6" vs-sm="10" vs-xs="11">
				<vx-card>
					<template slot="actions">
						<vx-tooltip class="flex" text="Hoe en wat?">
							<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
						</vx-tooltip>
					</template>
					<vs-row>
						<vs-col vs-w="12">
							<h1>Maak hier je gratis account aan</h1>
						</vs-col>
						<vs-col vs-w="12">
							Heb je al een account? <a @click="goToLogin" class="cursor-pointer">Log hier in</a>
						</vs-col>
					</vs-row>
					<br />
					<form>
						<vs-row>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|email'" name="email" ref="email" type="text"
										  class="inputLeft" label="E-mail"
										  v-model="newUser.email"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
							</vs-col>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|confirmed:email'" name="emailRepeat" type="text"
										  class="inputRight"
										  label="Herhaal je e-mail"
										  v-model="emailRepeat"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('emailRepeat')">{{ errors.first('emailRepeat') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|min:8'" name="password" ref="password" type="password"
										  class="inputLeft"
										  label="Wachtwoord"
										  v-model="newUser.password"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
							</vs-col>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|confirmed:password'" name="passwordRepeat"
										  type="password" class="inputRight"
										  label="Herhaal je wachtwoord"
										  v-model="passwordRepeat"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('passwordRepeat')">{{ errors.first('passwordRepeat') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|alpha_spaces'" name="name" type="text" class="inputLeft"
										  label="Naam"
										  v-model="newUser.name"></vs-input>
								<span class="text-danger text-sm"
									  v-show="errors.has('name')">{{ errors.first('name') }}</span>
							</vs-col>
							<vs-col vs-w="6">
								<vs-input
									v-validate="{required: true, regex:'^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))|(((\\\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$'}"
									name="phone" type="number" class="inputRight" label="Telefoon nummer"
									v-model="newUser.phone"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="6">
								<vs-input name="company" v-validate="'required|alpha_spaces'" type="text"
										  class="inputLeft" label="Bedrijfsnaam"
										  v-model="newUser.company"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('company')">{{ errors.first('company') }}</span>
							</vs-col>
							<vs-col vs-w="6">
								<vs-input name="chamberofcommercenumber" v-validate="'required|digits:8'" type="number"
										  class="inputRight"
										  label="Kvk nummer"
										  v-model="newUser.chamberofcommercenumber"></vs-input>
								<span class="text-danger text-sm"
									  v-show="errors.has('chamberofcommercenumber')">{{ errors.first('chamberofcommercenumber') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="12">
								<vs-input
									v-validate="{required: true, regex:'^([1-9][e][\\s])*([a-zA-Z]+(([\\.][\\s])|([\\s]))?)+[1-9][0-9]*(([-][1-9][0-9]*)|([\\s]?[a-zA-Z]+))?$'}"
									name="address" type="text" class="inputFull" label="Adres"
									v-model="newUser.address"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="6">
								<vs-input name="postalcode"
										  v-validate="{required: true, regex:'^[1-9][0-9]{3}[\\s]?[A-Za-z]{2}$'}"
										  type="text"
										  class="inputLeft"
										  label="Postcode" v-model="newUser.postalcode"></vs-input>
								<span class="text-danger text-sm" v-show="errors.has('postalcode')">{{ errors.first('postalcode') }}</span>
							</vs-col>
							<vs-col vs-w="6">
								<vs-input v-validate="'required|alpha_spaces'" name="city" type="text"
										  class="inputRight" label="Plaats"
										  v-model="newUser.city"></vs-input>
								<span class="text-danger text-sm"
									  v-show="errors.has('city')">{{ errors.first('city') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="12">
								<vs-input type="text" class="inputFull" label="Kortings code"
										  v-model="newUser.discount_code"></vs-input>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="12">
								<vs-input type="text" class="inputFull" label="Land" disabled="true"
										  v-model="newUser.country"></vs-input>
							</vs-col>
						</vs-row>
						<br />
						<vs-row>
							<vs-col vs-w="12">
								<vs-button @click.prevent="validateForm()">Acount aanmaken</vs-button>
							</vs-col>
						</vs-row>
					</form>

				</vx-card>
			</vs-col>
		</vs-row>
	</div>
</template>

<script>
import {mapActions} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);
const dict = {
	custom: {
		name: {
			required: 'Voer alsjeblieft je naam in',
			alpha_spaces: 'Je naam kan alleen uit letters bestaan'
		},
		phone: {
			required: 'Voer alsjeblieft je telefoon nummer in',
			regex: 'Dit is geen geldig telefoon nummer'
		},
		company: {
			required: 'Voer alsjeblieft je bedrijfs naam in',
			alpha_spaces: 'Je bedrijfs naam kan alleen uit letters bestaan'
		},
		chamberofcommercenumber: {
			required: 'Voer alsjeblieft je Kvk nummer in',
			digits: 'Je Kvk nummer moet 8 cijfers lang zijn'
		},
		password: {
			required: 'Voer alsjeblieft je wachtwoord in',
			min: 'Je wachtwoord moet minimaal 8 tekens lang zijn',
		},
		passwordRepeat: {
			required: 'Herhaal alsjeblieft je wachtwoord in',
			confirmed: 'Je wachtwoord is niet gelijk'
		},
		email: {
			required: 'Voer alsjeblieft je E-mail adres in',
			email: 'Dit is geen geldig E-mail adres'
		},
		emailRepeat: {
			required: 'Herhaal alsjeblieft je E-mail adres',
			confirmed: 'Je E-mail is niet gelijk'
		},
		address: {
			required: 'Voer alsjeblieft je adres in',
			regex: 'Dit is geen geldig adres'
		},
		postalcode: {
			required: 'Voer alsjeblieft je postcode in',
			regex: 'Dit is geen geldige postcode'
		},
		city: {
			required: 'Voer alsjeblieft je plaatsnaam in',
			alpha_spaces: 'Je plaatsnaam kan alleen uit letters bestaan'
		},
	}
};
Validator.localize('en', dict);

export default {
	name: 'register',

	data() {
		return {
			newUser: {
				email: '',
				password: '',
				name: '',
				phone: '',
				company: '',
				chamberofcommercenumber: '',
				address: '',
				postalcode: '',
				city: '',
				country: 'Nederland',
				discount_code: '',
			},
			loginData: {
				email: '',
				password: '',
			},
			emailRepeat: '',
			passwordRepeat: '',
		}
	},
	methods: {
		...mapActions({
			user: 'userStore/createUser',
			signIn: 'auth/signIn'
		}),
		validateForm() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.submitForm()
				} else {
					this.$vs.notify({
						title: 'Error',
						text: 'Controleer je gegevens en probeer opnieuw',
						time: '4000',
						color: 'danger'
					})
				}
			})
		},
		submitForm() {
			this.$vs.loading()
			this.$store.dispatch('userStore/createUser', this.newUser).then(res => {
				this.$vs.notify({
					title: 'Gelukt!',
					text: 'Je acount is aan gemaakt, je bent nu ingelogd',
					color: 'success',
					time: '4000'
				})
				this.loginData.email = this.newUser.email;
				this.loginData.password = this.newUser.password;
				this.signIn(this.loginData).then(() => {
					this.$vs.loading.close()
					this.$router.replace({
						name: 'dashboard'
					}).catch((err) => {
						this.$vs.loading.close()
						this.$vs.notify({
							title: 'Error',
							text: 'Er is iets fout gegaan',
							color: 'danger',
							time: '4000'
						})
					})
				}).catch((err) => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Error',
						text: 'Er is iets fout gegaan',
						color: 'danger',
						time: '4000'
					})
				})
			}).catch(err => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets fout gegaan',
					color: 'danger',
					time: '4000'
				})
			});
			this.$vs.loading.close()
		},
		goToLogin() {
			this.$router.replace({
				name: 'page-login'
			});
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.register)
		}
	}
}
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
}

.register {
	padding-top: 7%;
	height: 100vh;
	width: 100vw;
	align-content: center;
}

.registerBox {
}

.inputFull {
	width: 100%;
}

.inputLeft {
	width: 90%;
}

.inputRight {
	width: 100%;
}
</style>
